import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import {
  Autocomplete,
  IconButton,
  // MenuItem,
  TextField,
  Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AdditionalFilter from "./AdditionalFilter";
import BroadcastDialog from "./BroadcastDialog";
import "./CampaignDetails.css";

import {
  filteredAgents,
  filteredStatusCall,
  getDataCampaignColumnTable,
  getListAssignment,
} from "../Store/Actions/OutboundAction";

import { SET_CURRENT_ASSIGNMENT_ID, SET_TABLE_PAGE } from "../Store/Types/OutboundTypes";
import Telemarketing from "../Telemarketing/Telemarketing";

// const dummy = [
//   {
//     RecordID: 0,
//     contactName: "DANNY PRASADA LUBIS",
//   },

//   {
//     RecordID: 1,
//     contactName: "CANDRA ARIS SUHERMAN",
//   },

//   {
//     RecordID: 2,
//     contactName: "VERONIKA INAGIJAI",
//   },

//   {
//     RecordID: 3,
//     contactName: "SYARIFUDIN",
//   },

//   {
//     RecordID: 4,
//     contactName: "DRS H SUKANDI",
//   },

//   {
//     RecordID: 5,
//     contactName: "NURMAUKIDIA ULPAH",
//   },

//   {
//     RecordID: 6,
//     contactName: "MAX ZAKARIAS SOPACUA",
//   },

//   {
//     RecordID: 7,
//     contactName: "SYARIFUDIN PADJUNGE",
//   },

//   {
//     RecordID: 8,
//     contactName: "MARIKA OKINAWA",
//   },

//   {
//     RecordID: 9,
//     contactName: "CASSANDRA LIM",
//   },
// ];

const initialParams = {
  contactName: "",
  contactRef: "",
  agentName: "",
  status: "",
  statusCall: "",
  skip: 0,
};

const initialDisplayValues = {
  agentName: null,
  status: null,
  statusCall: null,
};

export default function CampaignDetails({
  setSelectedAssignment,
  campaignID,
  isTelemarketing,
}) {
  const [agentData, setAgentData] = useState([]);

  const [statusData, setStatusData] = useState([
    {
      Text: "New Assignment",
      Value: "1",
    },

    {
      Text: "Uncalled Today",
      Value: "2",
    },

    {
      Text: "All CallBack",
      Value: "3",
    },

    {
      Text: "Need Attention",
      Value: "4",
    },

    {
      Text: "Completed",
      Value: "5",
    },
  ]);

  const [statusCallData, setStatusCallData] = useState([]);
  const [searchParams, setSearchParams] = useState(initialParams);

  // Display values for autocomplete components
  const [displayValues, setDisplayValues] = useState(initialDisplayValues);

  // const [isSearchLoading, setIsSearchLoading] = useState(true);
  const [isSearchShown, setIsSearchShown] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [campaignColumns, setCampaignColumns] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [assignmentsTelMark, setAssignmentsTelMark] = useState([]);
  const [assignmentsToBroadcast, setAssignmentsToBroadcast] = useState([]);

  const [isAdditionalFilterDialogShown, setIsAdditionalFilterDialogShown] =
    useState(false);

  const [isBroadcastDialogShown, setIsBroadcastDialogShown] = useState(false);
  const dispatch = useDispatch();
  const { myInfo } = useSelector((state) => state.auth);
  const { tablePage } = useSelector((state) => state.outbound);
  console.log("assignmentsTelMark:", assignmentsTelMark);

  useEffect(() => {
    setIsLoading(true);

    const payload = {
      agentid: myInfo.user.AgentID,
      campaignid: campaignID,
      filter: `contact=${searchParams.contactName}|status=${searchParams.status}|agent=${searchParams.agentName}|contactref=${searchParams.contactRef}|statuscall=${searchParams.statusCall}`,
      skip: 0,
      take: 999,
      sorting: "",
      page: null,
      source: isTelemarketing ? 2 : 1,
    };

    getDataCampaignColumnTable(payload)
      .then((response) => {
        if (response.status) {
          console.log("Column table: ", response.data[0].ColumnString);
          setCampaignColumns(response.data[0].ColumnString);
        } else {
          console.log("error", response.error);
        }
      })
      .catch((err) => console.log("err", err));

    fetchAssignments();
  }, []);

  // Run on first load, get search options data
  useEffect(() => {
    // Get agent data for search select options
    filteredAgents({
      AgentID: myInfo.user.AgentID,
      CampaignID: campaignID,
      UserDataLevel: myInfo.user.Level,
      UserDataInheritLeaderAgent: 0, // TODO: currently hardcoded
      UserDataLeaderID: myInfo.user.LeaderID,
      UserDataClientID: myInfo.user.ClientID,
    })
      .then((response) => {
        if (response.status) {
          console.log("filtered agents", response.data);
          setAgentData(response.data[0]);
        } else {
          console.log("error", response.error);
        }
      })
      .catch((err) => console.log("err", err));

    // Get status call data for search select options
    filteredStatusCall({ CampaignID: campaignID })
      .then((response) => {
        if (response.status) {
          console.log("filtered status call", response.data);
          setStatusCallData(response.data[0]);
        } else {
          console.log("error", response.error);
        }
      })
      .catch((err) => console.log("err", err));

    // setIsSearchLoading(false);
  }, []);

  let columns = [];

  columns = campaignColumns.map((column) => {
    return {
      field: column,
      headerName: column,
      flex: 1,

      // Make column wider if column contains "alamat" or "addr"
      minWidth:
        column.toLowerCase().includes("alamat") ||
        column.toLowerCase().includes("addr")
          ? 360
          : 120,
    };
  });

  columns.unshift({
    field: "action",
    headerName: "Action",

    renderCell: (params) => {
      return (
        <IconButton
          onClick={() => {
            setSelectedAssignment(
              isTelemarketing ? params.row.AssignmentID : params.row.RecordID
            );

            dispatch({
              type: SET_CURRENT_ASSIGNMENT_ID,

              payload: {
                assignmentID: isTelemarketing
                  ? params.row.AssignmentID
                  : params.row.RecordID,
              },
            });
          }}
        >
          <Icon
            color="#7e7e7e"
            height="26"
            icon="ic:baseline-remove-red-eye"
            width="26"
          />
        </IconButton>
      );
    },

    width: 80,
  });

  const singleButtons = (
    <div className="single-buttons">
      <div className="toggle-filter">
        <p>Additional Filter : OFF</p>

        <div className="single_button">
          <Tooltip title="Toggle additional filters" arrow>
            <IconButton
              size="medium"
              onClick={() => setIsAdditionalFilterDialogShown(true)}
            >
              <Icon icon="mdi:filter-multiple-outline" width="28" height="28" />
            </IconButton>
          </Tooltip>
        </div>
      </div>

      <div className="single_button broadcast-button">
        <Tooltip title="Broadcast" arrow>
          <IconButton
            size="medium"
            onClick={() => setIsBroadcastDialogShown(true)}
          >
            <Icon
              icon="fluent:megaphone-loud-32-filled"
              width="28"
              height="28"
            />
          </IconButton>
        </Tooltip>
      </div>
    </div>
  );

  const fetchAssignments = (skip = 0) => {
    setIsLoading(true);

    const payload = {
      /* agentid: isTelemarketing
        ? myInfo.user.AgentTSS.AgentID
        : myInfo.user.AgentID, */

      agentid: myInfo.user.AgentID,
      campaignid: campaignID,
      filter: `contact=${searchParams.contactName}|status=${searchParams.status}|agent=${searchParams.agentName}|contactref=${searchParams.contactRef}|statuscall=${searchParams.statusCall}`,
      skip: skip,
      take: 50,
      source: isTelemarketing ? 2 : 1,
    };

    getListAssignment(payload)
      .then((response) => {
        if (response.status) {
          isTelemarketing
            ? setAssignmentsTelMark(response.data.campaigndatatable)
            : setAssignments(response.data.campaigndatatable[0]);
          setIsLoading(false);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err", err);
      });
  };

  return (
    <div className="campaign-details">
      <div className="container-header">
        {/* {isSearchLoading ? ( */}
        {isSearchShown ? (
          <>
            {/* <Loader /> */}

            <div className="search">
              <div className="row">
                <div className="single_button">
                  <Tooltip title="Search" arrow>
                    <IconButton
                      size="medium"
                      onClick={() => setIsSearchShown(false)}
                    >
                      <Icon height="28" icon="ph:x-bold" />
                    </IconButton>
                  </Tooltip>
                </div>

                <TextField
                  className="search-item"
                  label="Contact Name"
                  value={searchParams.contactName}
                  onChange={(event) =>
                    setSearchParams({
                      ...searchParams,
                      contactName: event.target.value,
                    })
                  }
                />

                {/* no idea what is this for
                {!isTelemarketing && (
                  <>
                    <TextField
                      className="search-item"
                      label="Contact Ref"
                      value={searchParams.contactRef}
                      onChange={(event) =>
                        setSearchParams({
                          ...searchParams,
                          customer: event.target.value,
                        })
                      }
                    />
                    {singleButtons}
                  </>
                )} */}
              </div>
              {console.log("level:", myInfo.user.Level)}

              <div className="row">
                {myInfo.user.Level > 0 ? (
                  <Autocomplete
                    className="search-item"
                    disableClearable
                    // filterSelectedOptions
                    // multiple
                    options={agentData}
                    value={displayValues.agentName}
                    getOptionLabel={(agent) => agent.Name}
                    onChange={(event, value) => {
                      setSearchParams({
                        ...searchParams,

                        // agentName: value?.length
                        //   ? value.map((val) => val.ID)
                        //   : "",

                        agentName: value.ID,
                      });

                      setDisplayValues({
                        ...displayValues,
                        agentName: value,
                      });
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Agent Name" />
                    )}
                  />
                ) : (
                  ""
                )}

                <Autocomplete
                  className="search-item"
                  disableClearable
                  // filterSelectedOptions
                  // multiple
                  options={statusData}
                  value={displayValues.status}
                  getOptionLabel={(option) => option.Text}
                  onChange={(event, value) => {
                    setSearchParams({
                      ...searchParams,

                      // status: value?.length
                      //   ? value.map((val) => val.Value)
                      //   : "",

                      status: value.Value,
                    });

                    setDisplayValues({
                      ...displayValues,
                      status: value,
                    });
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Status" />
                  )}
                />

                {!isTelemarketing && (
                  <Autocomplete
                    className="search-item"
                    disableClearable
                    // filterSelectedOptions
                    // multiple
                    options={statusCallData}
                    value={displayValues.statusCall}
                    getOptionLabel={(statusCall) => statusCall.Name}
                    onChange={(event, value) => {
                      console.log(value);

                      setSearchParams({
                        ...searchParams,

                        // statusCall: value?.length
                        //   ? value.map((val) => val.ID)
                        //   : "",

                        statusCall: value.ID,
                      });

                      setDisplayValues({
                        ...displayValues,
                        statusCall: value,
                      });
                    }}
                    renderInput={(params) => (
                      <TextField {...params} label="Status Call" />
                    )}
                  />
                )}
              </div>
            </div>

            <div className="search-buttons">
              <button
                className="clear-button"
                onClick={() => {
                  setSearchParams(initialParams);
                  setDisplayValues(initialDisplayValues);
                  fetchAssignments();
                }}
              >
                <Icon icon="ri:brush-3-line" width="20" height="20" />
                Clear
              </button>

              <button
                className="search-button"
                onClick={() => fetchAssignments()}
              >
                <Icon icon="mingcute:search-line" width="20" height="20" />
                Search
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="single_button">
              <Tooltip title="Search" arrow>
                <IconButton
                  size="medium"
                  onClick={() => setIsSearchShown(true)}
                >
                  <Icon height="28" icon="mingcute:search-line" />
                </IconButton>
              </Tooltip>
            </div>

            {isTelemarketing ? "" : singleButtons}
          </>
        )}
      </div>

      <div className="container-body">
        <DataGrid
          autoPageSize
          checkboxSelection
          className="table"
          columns={columns}
          disableColumnFilter
          disableColumnMenu
          disableSelectionOnClick
          headerHeight={75}
          keepNonExistentRowsSelected
          loading={isLoading}
          page={tablePage}
          pageSize={50}
          paginationMode={"server"}
          rowCount={
            isTelemarketing ? assignmentsTelMark.length : assignments.length
          }
          rows={isTelemarketing ? assignmentsTelMark : assignments}
          rowsPerPageOptions={[]} // hide rows per page
          selectionModel={assignmentsToBroadcast}
          getRowHeight={() => "auto"}
          getRowId={
            isTelemarketing ? (row) => row.AssignmentID : (row) => row.RecordID
          }
          onPageChange={(newPage) => {
            if (newPage > tablePage) {
              fetchAssignments(searchParams.skip + 50);

              setSearchParams((prevState) => {
                return {
                  ...searchParams,
                  skip: prevState.skip + 50,
                };
              });
            } else {
              fetchAssignments(searchParams.skip - 50);

              setSearchParams((prevState) => {
                return {
                  ...searchParams,
                  skip: prevState.skip - 50,
                };
              });
            }

            dispatch({
              type: SET_TABLE_PAGE,
              payload: { tablePage: newPage },
            });
          }}
          onSelectionModelChange={(newAssignmentsToBroadcast) =>
            setAssignmentsToBroadcast(newAssignmentsToBroadcast)
          }
        />
      </div>

      <AdditionalFilter
        isOpen={isAdditionalFilterDialogShown}
        setIsAdditionalFilterDialogShown={setIsAdditionalFilterDialogShown}
      />

      <BroadcastDialog
        campaignID={campaignID}
        isOpen={isBroadcastDialogShown}
        setIsBroadcastDialogShown={setIsBroadcastDialogShown}
        selectedContacts={assignmentsToBroadcast}
        statusOptions={statusData}
      />
    </div>
  );
}
